// extracted by mini-css-extract-plugin
export default {"wrapper":"Services_wrapper__FUtfx","card":"Services_card__UOAYH","icon":"Services_icon__JNtS5","title":"Services_title__wDa67","description":"Services_description__MZXIG"};